import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { LoginResponse, VertiLogin } from '@models/swagger';
import { VertiLoginParams } from './service';

export enum VertiLoginActions {
  Failure = '[Authentications VertiLogin] Failure',
  Request = '[Authentications VertiLogin] Request',
  Success = '[Authentications VertiLogin] Success',
}

export const VertiLoginFailure = createAction(VertiLoginActions.Failure, props<{ error: HttpErrorResponse }>());

export const VertiLoginRequest = createAction(
  VertiLoginActions.Request,
  props<{ body: VertiLogin; parameters?: VertiLoginParams }>()
);

export const VertiLoginSuccess = createAction(VertiLoginActions.Success, props<{ data: LoginResponse }>());
